import ReactDOM from "react-dom";
import { useState } from "react";
import e from "../style.module.css";
import { useLocation } from 'wouter';

import { Ilogin } from "../Login.models";

import Button from "components/common/Button/Button";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { InputGroup } from "react-bootstrap";

function ModalElem({ onSubmit, disableBtn, show }: Ilogin) {
  const [validated, setValidated] = useState(false);
  const [, setLocation] = useLocation();
  
  const handleSubmit = (event: any) => {
    const form = event.currentTarget;
    event.preventDefault();
    event.stopPropagation();
    
    if (form.checkValidity()) {
      onSubmit(event.target[0].value, event.target[1].value, false);
    }
    setValidated(true);
  };

  return (
    <>
      <Modal
        show={show}
        backdrop="static"
        dialogClassName="modal-lg"
        keyboard={false}
        animation={false}
        centered
      >
        <Modal.Body className="p-0">
          <Container>
            <Row>
              <Col
                xs={12}
                lg={5}
                className={`order-lg-2 ${e["login__panel-text"]}`}
              >
                <h3 className="mb-lg-3">Bienvenido a tu página de servicios</h3>
                <p>
                  Para que puedas adquirir nuevos productos, verificar tus
                  pólizas y gestionar reclamaciones.
                </p>
              </Col>
              <Col
                xs={12}
                lg={7}
                className={`order-lg-1 ${e["login__panel-button"]}`}
              >
                <h4>¡Hola!</h4>
                <p>Ingresa tu usuario</p>

                <Form className={`mt-2 not-valid-flags ${e.login__form}`}  noValidate validated={validated} onSubmit={handleSubmit}>
                  <Form.Group className="mb-3" controlId="validationUser">
                    <Form.Label>Usuario</Form.Label>
                    <InputGroup hasValidation>
                      <InputGroup.Text id="inputGroupPrepend">@</InputGroup.Text>
                      <Form.Control
                        type="text"
                        placeholder="Usuario"
                        aria-describedby="inputGroupPrepend"
                        required
                      />
                      <Form.Control.Feedback type="invalid">
                        Este campo es requerido.
                      </Form.Control.Feedback>
                    </InputGroup>
                  </Form.Group>

                  <Form.Group className="mb-3" controlId="validationPass">
                    <Form.Label>Password</Form.Label>
                    <Form.Control
                      type="password"
                      placeholder="Password"
                      required        
                    />
                    <Form.Control.Feedback type="invalid">
                      Este campo es requerido.
                    </Form.Control.Feedback>
                  </Form.Group>

                  <div className="d-flex justify-content-center">
                    <Button
                      type="submit"
                      className={`mb-3 ${e.modal__btn}`}
                      value="Ingresar"
                      onClick={() => onSubmit}
                      disabled={disableBtn}
                      showLoading={true}
                    />
                  </div>
                </Form>

                <button type="button" className={`text-muted ${e["modal__btn-pass"]} btn btn-link`} onClick={() => setLocation('/recovery')}>
                  <small>Olvidé mi contraseña</small>
                </button>
              </Col>
            </Row>
          </Container>
        </Modal.Body>
      </Modal>
    </>
  );
}

export const ModalLogin = ({ onSubmit, disableBtn, show}: Ilogin) => {
  const modalRoot = document.getElementById("modal-root") as HTMLElement;
  return ReactDOM.createPortal(
    <ModalElem
      onSubmit={onSubmit}
      show={show}
      // setUsername={setUsername}
      // setPassword={setPassword}
      disableBtn={disableBtn}
    />,
    modalRoot
  );
};
// function useState(arg0: boolean): [any, any] {
//   throw new Error("Function not implemented.");
// }

